import { useState, useEffect, useRef } from 'react';

const TypingAnimation = ({ content, onComplete, speed = 20 }) => {
  const [displayedContent, setDisplayedContent] = useState('');
  const [isComplete, setIsComplete] = useState(false);
  const contentRef = useRef(content);
  const indexRef = useRef(0);
  const onCompleteRef = useRef(onComplete);

  // Update refs when props change
  useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  useEffect(() => {
    contentRef.current = content;
    indexRef.current = 0;
    setDisplayedContent('');
    setIsComplete(false);

    const typeNextChar = () => {
      if (indexRef.current < contentRef.current.length) {
        const nextChar = contentRef.current[indexRef.current];
        setDisplayedContent(prev => prev + nextChar);
        indexRef.current++;
        
        // Variable speed for more natural typing
        let delay = speed;
        if (nextChar === '.' || nextChar === '!' || nextChar === '?') {
          delay = speed * 8; // Pause after sentences
        } else if (nextChar === ',') {
          delay = speed * 3; // Short pause after commas
        } else if (nextChar === '\n') {
          delay = speed * 5; // Pause after line breaks
        }
        
        setTimeout(typeNextChar, delay);
      } else {
        setIsComplete(true);
        if (onCompleteRef.current) onCompleteRef.current();
      }
    };

    // Start typing after a small delay
    const initialDelay = setTimeout(typeNextChar, 100);
    
    return () => clearTimeout(initialDelay);
  }, [content, speed]);

  return (
    <span className="typing-content">
      {displayedContent}
      {!isComplete && (
        <span className="inline-block w-0.5 h-4 bg-[#BA7B7C] ml-0.5 animate-pulse" />
      )}
    </span>
  );
};

export default TypingAnimation;
